export function hasAuthenticDemographics(
  gender: unknown,
  birthDate: unknown,
): birthDate is string {
  return (gender === 'M' || gender === 'F')
    && typeof birthDate === 'string'
    && /^\d{4}-\d{2}-\d{2}$/.test(birthDate)
}

export function isAuthenticGender(gender: unknown): gender is 'M' | 'F' {
  return gender === 'M' || gender === 'F'
}
